<div class="modal-body" *ngIf="kycData.id == 0" id="kyc">

    <div id="cancelModal" #cancelModal (click)='showStatus()'></div>
    <div class="modal-section">
        <iframe allow="camera" id='iframe' width="100%" height="100%" frameBorder="0" [src]="kycData.data"></iframe>
    </div>
</div>

<div class="modal-body" *ngIf="kycData.id == 1" id="kyc">

    <div id="cancelModal" #cancelModal (click)='showStatus()'></div>
    <div class="modal-section">
        <iframe allow="camera" id='iframe' width="100%" height="100%" frameBorder="0" [src]="kycData.data"></iframe>
    </div>
</div>

<div class="modal-body" *ngIf="kycData.id == 2" id="account">
    <div id="cancelModalAccount" #cancelModalAccount (click)='showStatus()'></div>
    <div class="modal-section">
        <iframe allow="camera" id='iframe' width="100%" height="100%" frameBorder="0" [src]="kycData.data"></iframe>
    </div>
</div>

<div class="modal-body" *ngIf="kycData.id == 3" id="eMandate">
    <div id="cancelModaleMandate" #cancelModaleMandate (click)='showStatus()'></div>
    <div class="modal-section">
        <iframe class="emandateFrame" allow="camera" id='iframe' width="100%" height="100%" frameBorder="0" [src]="kycData.data"></iframe>
    </div>
</div>

<div class="modal-body" *ngIf="kycData.id == 4" id="loanRestr" style="margin-left: -11px;margin-top: -2px">
    <div class="box">
        <div id="cancelModalLR" #cancelModalLR (click)='showStatus()'></div>
        <div class="modal-section">
            <!-- <embed class="emandateFrame" allow="camera" id='iframe' [src]="kycData.data" frameBorder="0" type="application/pdf" width="100%" height="100%" style="margin-top: 20px;height: 550px !important;" /> -->
            <!-- <iframe class="emandateFrame" allow="camera" src="https://docs.google.com/gview?kycData.data.pdf&embedded=true" style="width:600px; height:500px;" frameborder="0" [src]="kycData.data" style="margin-top: 20px;height: 550px !important;"></iframe> -->
            <iframe class="emandateFrame" allow="camera" id='iframe' width="100%" height="100%" frameBorder="0" [src]="kycData.data" style="margin-top: 20px;height: 550px !important;"></iframe>

            <!-- <div style="margin-top:15px;">
                <span><button class="reject" [hidden]="hidereject" (click)="ldsrejectedted()">Reject </button></span><span><button class="accept" (click)="ldsaccepted()" [hidden]="hideaccept">Accept</button></span>
            </div>
            <div class="" *ngIf="showLoader">
                <img src="assets/loading.gif" height="60">
            </div> -->

        </div>
    </div>
</div>